import { Controller } from 'stimulus';
import { openModal } from '@/js/modules/turbo-modal';

export default class extends Controller {
  static targets = ['paymentTrigger'];
  static values = {
    paymentUrl: String,
    paymentStatuses: { type: Array, default: ['paid', 'partial', 'partially_paid'] },
  };

  statusChanged(event) {
    const status = event.target.value;
    if (!this.paymentStatusesValue.includes(status)) {
      return;
    }

    const url = this.#paymentUrlFor(status);

    if (this.hasPaymentTriggerTarget) {
      this.#openPaymentDialog(url);
      return;
    }

    openModal(url)
      .then((paymentModal) => {
        if (paymentModal) {
          this.#handOffTo(paymentModal);
        }
      })
      .catch(console.error);
  }

  #openPaymentDialog(url) {
    const trigger = this.paymentTriggerTarget;
    const frameId = trigger.getAttribute('data-ui--twin-turbo-modal-trigger-frame-value');
    trigger.setAttribute('data-ui--twin-turbo-modal-trigger-url-value', url);
    this.dispatch('payment', { target: trigger });

    const frame = document.getElementById(frameId);
    frame.addEventListener('turbo:frame-load', () => this.#handOffTo(frame.closest('dialog')), {
      once: true,
    });
  }

  #handOffTo(paymentModal) {
    this.#closeStatusModal();
    // Closing the dialog hands focus back to its opener, which sits behind the payment modal.
    paymentModal.querySelector('form select, form input:not([type="hidden"])')?.focus();
  }

  #paymentUrlFor(status) {
    const url = new URL(this.paymentUrlValue, window.location.href);
    url.searchParams.set('status', status);

    return `${url.pathname}${url.search}`;
  }

  #closeStatusModal() {
    this.element.closest('dialog').close();
  }
}
